import Icon from '../components/Icon.vue'

Icon.register({
  'sort-amount-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M187.3 395.3L107.3 475.3C101.1 481.6 90.9 481.6 84.7 475.3L4.7 395.3C-5.4 385.2 1.8 368 16 368H64V48C64 39.2 71.2 32 80 32H112C120.8 32 128 39.2 128 48V368H176C190.2 368 197.3 385.3 187.3 395.3zM240 96H496C504.8 96 512 88.8 512 80V48C512 39.2 504.8 32 496 32H240C231.2 32 224 39.2 224 48V80C224 88.8 231.2 96 240 96zM224 208V176C224 167.2 231.2 160 240 160H432C440.8 160 448 167.2 448 176V208C448 216.8 440.8 224 432 224H240C231.2 224 224 216.8 224 208zM224 464V432C224 423.2 231.2 416 240 416H304C312.8 416 320 423.2 320 432V464C320 472.8 312.8 480 304 480H240C231.2 480 224 472.8 224 464zM224 336V304C224 295.2 231.2 288 240 288H368C376.8 288 384 295.2 384 304V336C384 344.8 376.8 352 368 352H240C231.2 352 224 344.8 224 336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-amount-down.js
// module id = JdYL
// module chunks = 144